import { AxiosRequestConfig } from 'axios';

export const getRequestConfig = (merchantId: string): AxiosRequestConfig => ({
  headers: {
    mid: merchantId,
  },
});
